import styled, { css } from 'styled-components';

interface IndexContainerProps {
  isActive: boolean;
}

export const StepIndicatorContainer = styled.div`
  width: 100%;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  position: relative;
`;

export const StepsContainerMask = styled.div`
  width: calc(100% - 2 * 1.875rem);
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  left: 1.875rem;

  position: absolute;

  z-index: 5;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;

  width: 5.25rem;

  span {
    text-align: center;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey2};
  }
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IndexContainer = styled.div<IndexContainerProps>`
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #e1e0e7;

  span {
    color: #c6c5ce;
    font-weight: 600;
  }

  ${({ isActive, theme }) =>
    isActive &&
    css`
      background: ${theme.colors.darkBlue};

      span {
        color: ${theme.colors.grey4};
      }

      border: transparent;
    `};
`;

export const IndexLine = styled.div`
  min-width: 120px;

  height: 1px;

  margin-top: 0.75rem;

  border-top: 1.5px solid #e1e0e7;
`;
